import React from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Title from '../../utils/title/Title';
import { useFormDetails } from '../../hooks/useFormDetails';
import { IHeaderType } from '../../types/types';






export default function BookingFormDetails() {


  const {
    formTitle,
    formSrc,
  } = useFormDetails()


  return (
    <Container>

      <Row>
        <Col>
          <Title
            textColor={""}
            text={formTitle}
            style={{
              textAlign: `center`
            }}
            type={IHeaderType.h2}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <div>
            <iframe
              width="100%"
              height="880px"
              title={formTitle}
              src={formSrc}
              style={{
                border: "none",
                maxWidth: "100%",
                maxHeight: "100vh"
              }}> </iframe>
          </div>
        </Col>
      </Row>

    </Container>
  )
}
